import Home from '../components/Home'
import PatientListReport from '../components/PatientListReport'
import PatientListPlan from '../components/PatientListPlan'
import PatientList from '../components/PatientList'
import ChangeList from '../components/ChangeList'
import ChangeDetail from '../components/ChangeDetail'
import DeliverySchedule from '../components/DeliverySchedule'
import MedicineList from '../components/MedicineList'
import MedicineDetail from '../components/MedicineDetail'
import MedicineEdit from '../components/MedicineEdit'
import ManageMedicine from '../components/ManageMedicine'
import Login from '../components/Login'
import MyPage from '../components/MyPage'
import ShopList from '../components/ShopList'
import ShopEditList from '../components/ShopEditList'
import ShopEdit from '../components/ShopEdit'
import FacilityList from '../components/FacilityList'
import FacilityEdit from '../components/FacilityEdit'
import FacilityDetail from '../components/FacilityDetail'
import FacilitySurrounding from '../components/FacilitySurrounding'
import FacilityPersonList from '../components/FacilityPersonList'
import ClinicList from '../components/ClinicList'
import ClinicEdit from '../components/ClinicEdit'
import ClinicDetail from '../components/ClinicDetail'
import ClinicSurrounding from '../components/ClinicSurrounding'
import DoctorList from '../components/DoctorList'
import DoctorDetail from '../components/DoctorDetail'
import DoctorEdit from '../components/DoctorEdit'
import CareOfficeList from '../components/CareOfficeList'
import CareOfficeDetail from '../components/CareOfficeDetail'
import CareOfficeEdit from '../components/CareOfficeEdit'
import CareOfficeSurrounding from '../components/CareOfficeSurrounding'
import CaremanList from '../components/CaremanList'
import CaremanDetail from '../components/CaremanDetail'
import CaremanEdit from '../components/CaremanEdit'
import ReportEdit from '../components/ReportEdit'
import ReportDetail from '../components/ReportDetail'
import ReportHistory from '../components/ReportHistory'
import ReportBatchHistory from '../components/ReportBatchHistory'
import PlanEdit from '../components/PlanEdit'
import PlanDetail from '../components/PlanDetail'
import MonthlyCheck from '../components/MonthlyCheck'
import PhraseList from '../components/PhraseList'
import Print from '../components/Print'
import SendPdf from '../components/SendPdf'
import SendPdfHistory from '../components/SendPdfHistory'
import ForgotPassword from '../components/ForgotPassword'
import ResetPassword from '../components/ResetPassword'
import Other from '../components/Other'
import NsipsPatientList from '../components/NsipsPatientList'
import NsipsClinicList from '../components/NsipsClinicList'
import NsipsDoctorList from '../components/NsipsDoctorList'
import NsipsReportEdit from '../components/NsipsReportEdit'
import NsipsRelationSituationList from '../components/NsipsRelationSituationList'
import OutPatientEdit from '../components/OutPatientEdit'
import OutPatientList from '../components/OutPatientList'
import OutPatientDetail from '../components/OutPatientDetail'

export default {
  data: [
    {name: 'home', path: '/', component: Home},
    {name: 'patientListReport', path: '/patients/report/:facilityId/:patientId', component: PatientListReport},
    {name: 'patientListPlan', path: '/patients/plan/:facilityId/:patientId', component: PatientListPlan},
    {name: 'patientList', path: '/patients/:facilityId/:type', component: PatientList},
    {name: 'patientList', path: '/patients/:type', component: PatientList},
    {name: 'selectPatientList', path: '/patients/:type/:medicineInformationId', component: PatientList},
    {name: 'patientMedicineList', path: '/patient/:patientId/medicines', component: MedicineList},
    {name: 'changeList', path: '/change', component: ChangeList},
    {name: 'changeDetail', path: '/change/:patientId', component: ChangeDetail},
    {name: 'deliverySchedule', path: '/delivery', component: DeliverySchedule},
    {name: 'medicineList', path: '/medicines', component: MedicineList},
    {name: 'medicineDetail', path: '/medicines/:medicineId', component: MedicineDetail},
    {name: 'medicineEdit', path: '/medicines/:medicineId/edit', component: MedicineEdit},
    {name: 'manageMedicine', path: '/manage/medicines', component: ManageMedicine},
    {name: 'myPage', path: '/mypage', component: MyPage},
    {name: 'login', path: '/login', component: Login, meta: {noAuth: true}},
    {name: 'forgotPassword', path: '/forgot_password', component: ForgotPassword, meta: {noAuth: true}},
    {name: 'resetPassword', path: '/reset_password', component: ResetPassword, meta: {noAuth: true}},
    {name: 'shopEditList', path: '/edit_shops', component: ShopEditList},
    {name: 'ShopEdit', path: '/shops/:shopId/edit', component: ShopEdit},
    {name: 'shopList', path: '/shops', component: ShopList},
    {name: 'facilityList', path: '/facilities', component: FacilityList},
    {name: 'facilityRegist', path: '/facilities/edit', component: FacilityEdit},
    {name: 'facilityEdit', path: '/facilities/edit/:facilityId/:facilityHistoryId', component: FacilityEdit},
    {name: 'facilityDetail', path: '/facilities/detail/:facilityId', component: FacilityDetail},
    {name: 'facilitySurrounding', path: '/facilities/surrounding', component: FacilitySurrounding},
    {name: 'facilityPersonList', path: '/facility_persons', component: FacilityPersonList},
    {name: 'facilityPersonEdit', path: '/facility_persons/edit/:facilityId/:facilityHistoryId', component: FacilityEdit},
    {name: 'facilityPersonRegist', path: '/facility_persons/edit', component: FacilityEdit},
    {name: 'facilityPersonDetail', path: '/facility_persons/detail/:facilityId', component: FacilityDetail},
    {name: 'facilityPersonSurrounding', path: '/facility_persons/surrounding', component: FacilitySurrounding},
    {name: 'clinicList', path: '/clinics', component: ClinicList},
    {name: 'clinicEdit', path: '/clinics/edit', component: ClinicEdit},
    {name: 'clinicEdit', path: '/clinics/:clinicId/:clinicHisId/edit', component: ClinicEdit},
    {name: 'clinicDetail', path: '/clinics/:clinicId', component: ClinicDetail},
    {name: 'clinicSurrounding', path: '/clinics/surrounding', component: ClinicSurrounding},
    {name: 'doctorList', path: '/doctors', component: DoctorList},
    {name: 'doctorList', path: '/doctors/list/:clinicId', component: DoctorList},
    {name: 'doctorEdit', path: '/doctors/edit', component: DoctorEdit},
    {name: 'doctorEdit', path: '/doctors/edit/:clinicId', component: DoctorEdit},
    {name: 'doctorEdit', path: '/doctors/:doctorId/:doctorHisId/edit', component: DoctorEdit},
    {name: 'doctorEdit', path: '/doctors/:doctorId/:doctorHisId/edit/:clinicId', component: DoctorEdit},
    {name: 'doctorDetail', path: '/doctors/:doctorId', component: DoctorDetail},
    {name: 'doctorDetail', path: '/doctors/:doctorId/:clinicId', component: DoctorDetail},
    {name: 'CareOfficeList', path: '/care_offices', component: CareOfficeList},
    {name: 'CareOfficeEdit', path: '/care_offices/edit', component: CareOfficeEdit},
    {name: 'CareOfficeEdit', path: '/care_offices/edit/:careOfficeHisId', component: CareOfficeEdit},
    {name: 'CareOfficeDetail', path: '/care_offices/:careOfficeId', component: CareOfficeDetail},
    {name: 'careOfficeSurrounding', path: '/care_offices/surrounding', component: CareOfficeSurrounding},
    {name: 'caremanList', path: '/care_managers', component: CaremanList},
    {name: 'caremanList', path: '/care_managers/list/:careOfficeId', component: CaremanList},
    {name: 'caremanEdit', path: '/care_managers/edit/', component: CaremanEdit},
    {name: 'caremanEdit', path: '/care_managers/edit/:careOfficeId', component: CaremanEdit},
    {name: 'caremanEdit', path: '/care_managers/:caremanId/:caremanHisId/edit', component: CaremanEdit},
    {name: 'caremanEdit', path: '/care_managers/:caremanId/:caremanHisId/edit/:careOfficeId', component: CaremanEdit},
    {name: 'caremanDetail', path: '/care_managers/:caremanId', component: CaremanDetail},
    {name: 'caremanDetail', path: '/care_managers/:caremanId/:careOfficeId', component: CaremanDetail},
    {name: 'ReportEdit', path: '/reports/:facilityId/edit', component: ReportEdit},
    {name: 'ReportEdit', path: '/reports/:facilityId/:patientId/:reportId/edit', component: ReportEdit},
    {name: 'ReportEdit', path: '/reports/send/:type/:facilityId/:patientId/:reportId/edit', component: ReportEdit},
    {name: 'ReportDetail', path: '/reports/detail/:facilityId/:patientId/:reportId', component: ReportDetail},
    {name: 'ReportDetail', path: '/reports/send/detail/:type/:facilityId/:patientId/:reportId', component: ReportDetail},
    {name: 'ReportHistory', path: '/reports/history/:type/:id', component: ReportHistory},
    {name: 'ReportBatchHistory', path: '/reports/batch_history/:type/:id', component: ReportBatchHistory},
    {name: 'PlanCreate', path: '/plans/create', component: PlanEdit},
    {name: 'PlanCreate', path: '/plans/create/:outpatientId', component: PlanEdit},
    {name: 'PlanCreate', path: '/plans/create/:facilityId/:patientId/:planId', component: PlanEdit},
    {name: 'PlanDetail', path: '/plans/detail/:facilityId/:patientId/:planId', component: PlanDetail},
    {name: 'PlanDetail', path: '/plans/detail/:facilityId/:patientId/:planId/:type', component: PlanDetail},
    {name: 'PlanEdit', path: '/plans/edit/:planId', component: PlanEdit},
    {name: 'PlanEdit', path: '/plans/edit/:facilityId/:patientId/:planId', component: PlanEdit},
    {name: 'MonthlyCheck', path: '/monthly_check', component: MonthlyCheck},
    {name: 'sendPdfHistory', path: '/send_pdf_history', component: SendPdfHistory},
    {name: 'PhraseList', path: '/phrases', component: PhraseList},
    {name: 'print', path: '/print', component: Print},
    {name: 'sendPdf', path: '/send_pdf', component: SendPdf},
    {name: 'nsipsPatientList', path: '/nsips/patients/list', component: NsipsPatientList},
    {name: 'nsipsClinicList', path: '/nsips/clinics/list', component: NsipsClinicList},
    {name: 'nsipsDoctorList', path: '/nsips/doctors/list', component: NsipsDoctorList},
    {name: 'nsipsReportEdit', path: '/nsips/reports/:facilityId/:patientId/:reportId/edit', component: NsipsReportEdit},
    {name: 'nsipsReportEdit', path: '/nsips/reports/:facilityId/edit', component: NsipsReportEdit},
    {name: 'nsipsRelationSituationList', path: '/nsips/relation_situations/list', component: NsipsRelationSituationList},
    {name: 'OutPatientEdit', path: '/outpatients/edit', component: OutPatientEdit},
    {name: 'OutPatientEdit', path: '/outpatients/edit/:outpatientId', component: OutPatientEdit},
    {name: 'OutPatientDetail', path: '/outpatients/detail/:outpatientId', component: OutPatientDetail},
    {name: 'OutPatientList', path: '/outpatients/list/', component: OutPatientList},
    {name: 'OutPatientList', path: '/outpatients/list/:outpatientId', component: OutPatientList},
    {name: 'other', path: '*', component: Other}
  ]
}



// WEBPACK FOOTER //
// ./src/router/routes.js